import store from 'src/store';
import {
  isBOE,
} from 'src/const/boe';
import {
  athenaLink,
} from 'src/const/state/self-service-config';

// 支付方式
export const paymethodTypeMap = {
  PREDIT: 1, // 先付款
  CREDIT: 2,
  CREDIT_LINE: 3,
};

// 计费方式
export const paymentTaxType = {
  default: -1,
  costPay: 0,
  chargePay: 1,
};

// 授信入口类型
export const creditlineApplyStatus = {
  LIMIT: 1, // 不展示入口
  CAN_APPLY: 2, // 可申请
  UNDER_REVIEWING: 3, // 审核中
  APPROVAL: 4, // 审核通过
  REJECTED: 5, // 审核拒绝
  UNDER_ADDINFO: 6, // 等待补充信息
};

// 是否披露税务信息
export const showTaxType = {
  display: 1,
  notDisplay: 2,
};

export const getPaymentCheckOutUrl = (url, return_url = '') => {
  const isSelfAccount = store.getters['account/isSelfAccount']; // 自助账号
  const adverId = store.getters['account/adverId']; // aadvid
  const paymentUrl = `${window.location.origin}/i18n/account/payment?aadvid=${adverId}`;
  let destUrl = return_url ? `${url}&return_url=${encodeURIComponent(return_url)}` : `${url}&return_url=${encodeURIComponent(paymentUrl)}`;
  // 自助账号需要雅典娜提供雅典娜反馈入口
  if (isSelfAccount) {
    const report_url = athenaLink();
    destUrl = `${destUrl}&report_url=${encodeURIComponent(report_url)}`;
  }
  return destUrl;
};

// ///////////// Payment SDK 需求通用配置 ///////////////
export const SDK_USE = 1;

export const upayStatus = {
  SUCCESS: 1,
  FAIL: 0,
};
export const submitModule = {
  PAY: 'pay',
  CREATE: 'create',
};
// 和 https://bytedance.feishu.cn/docs/doccnhsNPFAjc5482dapjmB5Ghc 同步更新
export const upayEvent = {
  // listened events
  DID_MOUNT: 'upay_did_mount',
  CAN_SUBMIT: 'upay_can_submit',
  CANNOT_SUBMIT: 'upay_cannot_submit',
  SUBMITTED: 'upay_do_submit',
  STATUS_RESULT: 'upay_status_result',
  PAYMENT_TRANSFER: 'upay_payment_transfer',
  MANAGER_DELETE_CARD: 'upay_manager_delete_card_success',
  // trigger events
  TRIGGER_SUBMIT: 'upay_submit',
  TRIGGER_OPEN_PAYMENT_TRANSFER: 'upay_open_payment_transfer',
  TRIGGER_CLOSE_NEW_TAB: 'upay_close_new_tab',
  TRIGGER_OPEN_MANAGER_ADD_CARD_MODAL: 'upay_open_manager_add_card',
  TRIGGER_REFRESH_MANAGER_LIST: 'upay_refresh_manager_list',
};
// Payment SDK 需求 自定义 emit 事件名称
export const upayEmitEvent = {
  UPAY_SUCCESS: 'success',
  UPAY_FAIL: 'fail',
  UPAY_PIXEL_FINISHED: 'pixel-finished',
  AMOUNT_SUBMIT: 'submit',
  MANAGER_DELETE_PAYMENT: 'delete-payment',
  QUAL_PREPAY_SUCCESS: 'qual-prepay-success',
  QUAL_POSTPAY_SUCCESS: 'qual-postpay-success',
  QUAL_PREPAY_FAIL: 'qual-prepay-fail',
  QUAL_POSTPAY_FAIL: 'qual-postpay-fail',
};
export const commonEmitEvent = {
  PREPAY_SDK_MODAL_BACK: 'prepay-sdk-modal-back',
  CREDIT_PERIOD_LOADED: 'credit-period-loaded',
  REFRESH_MANAGER_LIST: 'refresh-manager-list',
};
export const resultActionType = {
  BIND: 'bind',
  PAY: 'pay',
  CHANGE: 'change',
};
export const getCommonPolicyUrl = language => `https://www.tiktok.com/legal/privacy-policy?lang=${language}`;

// 卡管理模块相关
export const OPEN_BIND_CARD_DELAY = 100; // 卡管理模块绑卡失败重打开绑卡弹窗延迟

// 充值计税弹窗相关
export const AMOUNT_PENDING_STR = '-';
export const AMOUNT_ZERO_STR = 0;
export const CHECK_AMOUNT_INTERVAL = 1000;

// ///////////// pixel 落地页相关 ///////////////
// 技术方案：https://bytedance.feishu.cn/docs/doccnyHWKr05qc649bi0hr1v2Rc
export const UPAY_CLICK_BTN_INIT = -1;
export const PIXEL_IFRAME_LOADING_TIME_MAXIMUM = 5000; // 允许 iframe 上报的时间限制，超出这个时间就得
export const GET_STARTED_PIXEL_MESSAGE_SOURCE = 'getstarted-payment-pixel';
export const SECURE_ORIGIN = isBOE ?
  'https://boei18n-ads.byteoversea.net' :
  'https://getstarted.tiktok.com';
export const GET_STARTED_PIXEL_URL = isBOE ?
  'https://boei18n-ads.byteoversea.net/getstarted/payment/result-iframe' :
  'https://getstarted.tiktok.com/payment/result-iframe';

export const GetstartedPixelQueryType = {
  PRE_PAY: 'PRE_PAY', // 预付费
  BINDCARD: 'BINDCARD', // 绑卡
  PAY_UNPAID_BILL: 'PAY_UNPAID_BILL', // 后付费支付未付账单
};

export const GetstartedPixelQueryStatus = {
  SUCCESS: 'SUCCESS', // 成功
  FAIL: 'FAIL', // 失败
};

export const GetstartedPixelMessageData = {
  MOUNTED: 'MOUNTED', // mounted
  FINISH: 'FINISH', // 完成
};

export const GetstartedPixelQuerySource = {
  SHOPIFY: 'shopify', // shopify
  AD_MANAGER: 'ad_manager', // tt 广告平台
};

// 埋点上报相关
export const UPAY_PAGE_SOURCE = {
  QUALIFICATION: '1',
  PAYMENT: '2',
};

export const GROUP_ID_SDK = '1';

export const PREPAY_GROUP_ID = {
  SDK_USE: '1',
  SDK_NOT_USE: '2',
};

export const PREPAY_AMOUNT_SOURCE = {
  SELECT: '1',
  INPUT: '2',
};

/**
 * Helper to add event listeners to refs according to given config
 * @param {*} $this VueJS instance
 * @param {*} listenerConfig { refStrs: refConfig }, each refConfig is a nested object { eventName: listener }
 * @returns None
 */
export const addEventListenersToRefs = ($this, listenerConfig) => {
  for (const [refStr, refConfig] of Object.entries(listenerConfig)) {
    if (!$this.$refs[refStr]) continue;
    for (const [eventName, listener] of Object.entries(refConfig)) {
      $this.$refs[refStr].$on(eventName, listener);
    }
  }
};

// 创编接入支付事件
export const creativePaymentEvent = {
  SHOW_AD_CREATE_DIALOG: 'ad-create-show-dialog',
  CLOSE_AD_CREATE_DIALOG: 'ad-create-hide-dialog',
  SKIP_AD_CREATE_PAYMENT: 'ad-create-payment-skip',
  PAYMENT_RESOLVE: 'ad-create-payment-resolve',
  PAYMENT_PIXEL_FINISHED: 'ad-create-payment-pixel-finished',
  UPAY_LINK_READY: 'ad-create-upay-link-ready',
  SUCCESS_UPAY: 'ad-create-upay-success',
  FAIL_UPAY: 'ad-create-upay-fail',
};

export const UNLIMITED_CALC_DURATION = 1;
export const defaultCountry = 'US';
export const defaultCurrency = 'USD';

export const SourceMode = {
  NONE: -1, // 无
  SIMPLIFIED: 1, // pclite 0创编
  CUSTOM: 2, // pc 常规创编
  SIMPLIFIED_05: 3, // pclite 0.5创编
  CUSTOM_AUTOMATED: 4, // pc 程序化创编
  CUSTOM_ACCOUNT_INFO: 5, // pc account setting 页面
  CUSTOM_BANNER: 6, // pc banner
  CUSTOM_TRANSACTION: 7, // pc transaction 模块
  MANAGER_CREATION_NORMAL: 8, // 重构创编-普通创意
  MANAGER_CREATION_AUTOMATIC: 9, // 重构创编-程序化创意
  TIKTOK_BUSINESS_PLUGIN: 10, // TBP
  FAST_QUALIFICATION_PAGE: 12, // 资质简化前置页面
  FAST_ONBOARDING_PAGE: 13, // 新手引导页面
};

export const CreationMode = {
  TTAM_PANDA: 'TTAM_PANDA',
  TTAM_PANDA_AUTOMATED: 'TTAM_PANDA_AUTOMATED',
};

export const SourceModeTitleMap = Object.keys(SourceMode).reduce((total, key) => {
  total[SourceMode[key]] = key;
  return total;
}, {});

// 预付转后付功能实验
// 存储到本地的key，只出现一次
export const PAYMENT_SWITCH_AUTOPAY_STORAGE_TEST_KEY = 'payment_method_popover_state';
// 实验出现的入口，数组，item为路由名
export const PAYMENT_SWITCH_AUTOPAY_TEST_ENTRY = ['account_complete', 'payment'];

// 额度共享
export const SHARED_TYPE = {
  NOE_SHARE: 0, // 非共享
  CUR_SHARE: 1, // 当前共享
  CUR_NOT_SHARE: 2, // 有过共享, 当前非共享
};

// 预算类型
export const BUDGET_MODE = {
  UNLIMITED: 0, // 不限预算
  MI_MODE: 3, // 月预算
};

// 授信入口类型
export const UPGRADE_PAY_STATUS = {
  DISABLE: 1, // 不可升级
  CAN_APPLY: 2, // 可申请
  UNDER_REVIEWING: 3, // 审核中
  REJECTED: 4, // 审核拒绝
  UNDER_ADDINFO: 5, // 等待补充信息
  UNDER_CURRENT_METHOD: 6, // 当前处于本结算方式
};

// 支付升级的map转换（新旧接口返回的数据map对应）
export const UPGRADE_PAY_STATUS_MAP = {
  [UPGRADE_PAY_STATUS.DISABLE]: creditlineApplyStatus.LIMIT,
  [UPGRADE_PAY_STATUS.CAN_APPLY]: creditlineApplyStatus.CAN_APPLY,
  [UPGRADE_PAY_STATUS.UNDER_REVIEWING]: creditlineApplyStatus.UNDER_REVIEWING,
  [UPGRADE_PAY_STATUS.REJECTED]: creditlineApplyStatus.REJECTED,
  [UPGRADE_PAY_STATUS.UNDER_ADDINFO]: creditlineApplyStatus.UNDER_ADDINFO,
  [UPGRADE_PAY_STATUS.UNDER_CURRENT_METHOD]: creditlineApplyStatus.APPROVAL,
};
